import { render, staticRenderFns } from "./monitorList.vue?vue&type=template&id=0f5a28fb&"
import script from "./monitorList.vue?vue&type=script&lang=ts&"
export * from "./monitorList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports